import React from 'react';

const TeeCard = (props)=> {
    const { book, onBookSelect, isBookingAllowed } = props;

    return(<>
        <div  className="col-md-6 col-sm-6 col-lg-3 padding-0" >            
            <div className={`slot-card ${ ((!!book.Status && book.Status != 'Cancelled') || (isBookingAllowed) ) && 'disableClick'}`} onClick={() => onBookSelect(book)} >
                <div className={`${ (!book.Status) ? 'slot-card-header': (book.Status == 'Pending') ? 'slot-card-header-pending': (book.Status == 'Cancelled') ? 'slot-card-header-cancel' : (book.Status == 'FCFS') ? 'slot-card-header-fcfs' : 'slot-card-header-blur' }`}> 
                    <div className="row margin-0">
                        <div className="col-xs-12 padding-0">
                            <b> {book.Slot} </b>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>);
}


export default TeeCard;